import React, { Component } from 'react';
import Helmet from "react-helmet";

import Results from '../../components/results/';

export default ({match}) => ( 
	<div className="results-index">
		<Helmet>
			<title>ИРМ-результаты</title>
		</Helmet>
		<Results mode="line"/>
	</div> 
)


// WEBPACK FOOTER //
// ./src/routes/results/index.js